import Router from "../..";
import { useUserStore } from "../../../stores/userStore";

export const CampaignManagement = () => {
  const { userInfo } = useUserStore();

  if (userInfo?.user_info?.user_type === "brand") {
    return <Router.BrandCampaignManagement />;
  }

  if (userInfo?.user_info?.user_type === "agency") {
    return <Router.AgencyCampaignManagement />;
  }

  return null;
};
